module.exports = "<div >\n  <div md-whiteframe=\"1\" class=\"content-box text-center\">\n    <div translate=\"POLICY\"></div>\n  </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/users/policy.html
// module id = 261
// module chunks = 0